import { NgFor } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';

import { TranslocoPipe } from '@jsverse/transloco';

import { UiIconsModule } from 'ui-icons';

import { LanguageCode, LanguageService } from '../../../../../../../../shared/modules/language/services/language.service';
import { MainNavLanguageFlagComponent } from '../main-nav-language-flag/main-nav-language-flag.component';

@Component({
  selector: 'sh-main-nav-languages-mobile',
  imports: [
    NgFor,
    UiIconsModule,
    TranslocoPipe,
    MainNavLanguageFlagComponent
  ],
  templateUrl: './main-nav-languages-mobile.component.html',
  styleUrl: './main-nav-languages-mobile.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MainNavLanguagesMobileComponent {
  @Output() closeLanguageBar = new EventEmitter();
  @Output() closeMenu = new EventEmitter();

  constructor(public languageService: LanguageService) {}

  chooseLanguage(languageCode: LanguageCode) {
    this.languageService.changeLanguage(languageCode).then(() => {});
    this.closeMenu.emit();
  }

  onCloseLanguageBar() {
    this.closeLanguageBar.emit();
  }
}
